var _span;
import Checkmark from '@crehana/compass.icons.outline/Checkmark';
import { clsx } from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * This component doesn't use the `li` html tag. You must it when mapping/iterating over your items.
 * Example:
 * ````
 *  <li key={item.value}><ListItemDefault>{item.label}</ListItemDefault></li>
 * ````
 */
export var ListItemDefault = function ListItemDefault(_ref) {
  var children = _ref.children,
    highlighted = _ref.highlighted,
    selected = _ref.selected,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'l' : _ref$size,
    className = _ref.className,
    multilineOption = _ref.multilineOption;
  return /*#__PURE__*/_jsx("div", {
    className: clsx('tw-w-full', {
      'tw-h-5.6': size === 'l' && !multilineOption,
      'tw-h-4.8': size === 's' && !multilineOption
    }, className),
    children: /*#__PURE__*/_jsxs("span", {
      className: clsx('tw-flex tw-justify-between tw-items-center tw-py-1.2 tw-px-1.6 tw-font-body4 tw-cursor-pointer dark:tw-text-neutral-light-100', 'tw-bg-neutral-light-100 dark:tw-bg-neutral-dark-700',
      // these clases are the same sa the one for hightlighted and selected because we need apply the same styles on hover not only when the item is selected
      'hover:tw-bg-neutral-light-300 dark:hover:tw-bg-neutral-dark-600', 'hover:tw-text-primary-light-500 dark:hover:tw-text-neutral-light-100',
      // Keep using `highlighted` (even if it applies duplicated class names) prop because it comes from the library `downshift`.
      {
        'tw-bg-neutral-light-300 dark:tw-bg-neutral-dark-600': highlighted || selected,
        'tw-text-primary-light-500 dark:tw-text-neutral-light-100': highlighted || selected
      }),
      children: [/*#__PURE__*/_jsx("span", {
        children: children
      }), selected && (_span || (_span = /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(Checkmark, {
          size: 24,
          className: "tw-text-success-400"
        })
      })))]
    })
  });
};
export default ListItemDefault;